export default {
  updateCurrentPopup(state, obj) {
    state.currentPopup = obj;
  },

  updateDangerPopup(state, { isOpen = false, text = '' }) {
    state.dangerPopup.isOpen = isOpen;
    state.dangerPopup.text = text;
  },

  updatePopupModelAbout(state, data) {
    state.popupModelAbout = data;
  },

  updateCurrentPopover(state, obj) {
    state.currentPopover = obj;
  },

  setIsUpdateOrders(state, isValue = false) {
    state.isUpdateOrders = isValue;
  },

  updateSectionActive(state, val) {
    state.currentPopover.name = null;
    state.currentPopover.state = null;
    state.sectionActive = val;
  },

  updateCountry(state, val) {
    state.country = val;
  },

  updatePreload(state, val) {
    if (val !== undefined && val !== '') {
      state.preload = val;
    } else {
      state.preload = !state.preload;
    }
  },

  updateRoute(state, route) {
    state.route = route;
  },
};
